import { Flex, Heading, Icon, Spacer, Text } from '@chakra-ui/react';
import ArrowLight from 'images/icons/arrow-right-light.svg';
import Link from 'next/link';

type ChartPointProps = {
  title: string;
  points: Array<{ id: string; textListItem: string } | null>;
  index: number;
};

export const ChartPoint = ({ title, points, index }: ChartPointProps) => {
  const getUrlByIndex = (index: number): string => {
    switch (index) {
      case 0:
        return 'pages/ideation-services';
      case 1:
        return 'pages/design-services';
      case 2:
        return 'pages/software-development-services';
      case 3:
        return 'pages/maintenance-services';
      case 4:
        return 'pages/cooperation-models';
      case 5:
        return 'pages/ai-data-science';
      default:
        return ``;
    }
  };
  const url = getUrlByIndex(index);
  return (
    <>
      <Link href={`/${url}`}>
        <Flex
          flexDir="column"
          alignItems="stretch"
          h="100%"
          maxW={{ base: '260px' }}
          minW={{ base: '260px' }}
          px="30px"
          pt="40px"
          pb="40px"
          justify="flex-start"
          borderRadius="6px"
          padding="24px"
          height={{ base: '300px' }}
          bg="rgba(255, 255, 255, 0.10)" // bardziej mleczne tło
          backdropFilter="blur(20px)" // mocniejsze rozmycie
          border="1px solid rgba(255, 255, 255, 0.2)"
          color="white"
          position="relative"
          transition="all 0.3s ease"
          box-shadow="0px 0px 6px 0px #FFFFFF14 inset"
          _hover={{
            bg: 'rgba(255, 255, 255, 0.15)',
            transform: 'translateY(-5px)',
          }}
          marginRight="12px"
        >
          <Heading
            as="h3"
            color="beige.100"
            fontFamily={'body'}
            maxWidth="240px"
            fontWeight={500}
            fontSize="20px"
            mb={{ base: 4, lg: 6 }}
          >
            {title}
          </Heading>
          <Flex flexDir="column">
            {points.map((point, index) => (
              <Text
                key={point?.id}
                variant={{ base: 'component-paragraph-headline/sm' }}
                color="beige.100"
                mb={index !== points.length - 1 ? 2 : 0}
              >
                {point?.textListItem}
              </Text>
            ))}
          </Flex>
          <Spacer />
          <Flex justifyContent="flex-end" alignItems="end">
            <Icon as={ArrowLight} boxSize="40px" />
          </Flex>
        </Flex>
      </Link>
    </>
  );
};
